import { CustomDateFormatPipe } from '../../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { MapfreButtonComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { AutopayCardEnrollementFormComponent } from '../../../autopay/autopay-card-enrollement-form/autopay-card-enrollement-form.component';
import { EnrollEftEpayFormComponent } from '../../../../../../forms/dynamic-forms/enroll-eft-epay-form/enroll-eft-epay-form.component';
import { MapfreAlertComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { EnrollEftEpayService } from '../../../../../../../_services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '@services/data-services/policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, EnrollEftEpayFormComponent, AutopayCardEnrollementFormComponent, MapfreButtonComponent, CustomDateFormatPipe],
  selector: 'app-enroll',
  templateUrl: './enroll.component.html',
  providers: [EnrollEftEpayService],
})
export class PaperlessPayEnrollComponent implements OnInit {
  inputs: any[];
  whereInTheProcess: string;
  policyid: any;
  policy: any;
  isAcmic: boolean;
  loading = true;
  showTermsConditions = false;
  isCreditDebitCardMethod: boolean;

  constructor(
    private service: EnrollEftEpayService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private acmicService: AcmicService,
    private policyDataService: PolicyDataService,
  ) {
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.queryParams.subscribe(params =>{
      const paymentMethod = params['method'] as string;
      this.isCreditDebitCardMethod = paymentMethod && paymentMethod === "card";
      console.log("isCreditDebitCardMethod : ", paymentMethod, this.isCreditDebitCardMethod)
    });  
    
    const path = this.activatedRoute.snapshot.routeConfig.path;
    this.whereInTheProcess = path.split('/')[1];
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyid = params['policyid'];
      this.inputs = this.service.getInputs(this.policyid);
    });

    this.setPolicyInfo();
  }

  navigateBack() {
    let prevEftRoute = this.service.getPrevEftRoute();
    if (prevEftRoute == '') {
      prevEftRoute = `/my-insurance/${this.policyid}/billing`;
    }
    this.router.navigateByUrl(prevEftRoute);
  }

  setPolicyInfo(){
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
          if (policyResponse) {
            policyResponse.filter((policy) => {
              if (policy.policynumber.policyNumber === this.policyid) {
                this.policy = policy;                
              }
            });
            this.loading = false;
          }
        });
  }

  onShowTermsConditionsEvent(isDisplayed: boolean){
    this.showTermsConditions = isDisplayed;
  }
}
